import styled from 'styled-components';
import { breakpoints } from "../../../../utils/styledBreakpoints";

export const Container = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: row;
    ${breakpoints("flex-direction", "", [{ 992: `column` }])};
    ${breakpoints("background", "", [{ 992: `var(--sidebar-color)` }])};
`;